var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        width: 1200,
        scrollable: "",
        "class-name": "vertical-center-modal",
      },
      on: { "on-visible-change": _vm.onVisibleChange },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c("p", { attrs: { slot: "header" }, slot: "header" }, [
        _c("span", [_vm._v("批量编辑产品基础信息")]),
      ]),
      _c("Loading", { attrs: { isLoading: _vm.saveLoading } }),
      _c(
        "Tabs",
        {
          attrs: { animated: false, "capture-focus": true },
          model: {
            value: _vm.editType,
            callback: function ($$v) {
              _vm.editType = $$v
            },
            expression: "editType",
          },
        },
        [
          _c(
            "TabPane",
            { attrs: { label: "产品列表", name: "productInfo" } },
            [
              _c("productPopupEditTabBathProductList", {
                ref: "productList",
                on: { "chang-template-product": _vm.setProductUuid },
              }),
            ],
            1
          ),
          _c(
            "TabPane",
            { attrs: { label: "选择要修改的属性", name: "productInfo2" } },
            [
              _c("productPopupEditTabBathInfoList", {
                ref: "propBathTab",
                on: { "set-props-event": _vm.setPropsList },
              }),
            ],
            1
          ),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                { attrs: { label: "基础信息", name: "productInfo3" } },
                [
                  _c("ProductPopupEdit", {
                    ref: "productPopupEdit",
                    attrs: {
                      showPropList: _vm.showPropList,
                      dataPath: _vm.getUploadData(),
                      popupEditResource: _vm.popupEditResource,
                    },
                    on: { "on-popup-submit-finish": _vm.popupSubmitFinish },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          this.$checkAccessArray(["B", "C"])
            ? _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveListProductDescriptiveInformation },
                },
                [_vm._v("保存基础信息")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }